<template>
  <div>
    <el-card class="box-card">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/goods' }">
          <span style="font-size:14px">商品管理</span>
        </el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/goodsItem' }">
          <span style="font-size:14px">查看内容</span>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </el-card>

    <el-card class="box-card" style="margin-top: 20px;">
      <div style="display:flex">
        <div style="margin-right:20px;">
          <img
            width="200"
            height="120"
            :src="goodsItemIdData?goodsItemIdData.logo:'../../../static/image/noImg.png'"
          />
        </div>
        <div>
          <span style="font-size:20px;">{{this.goodsItemIdData.name}}&nbsp;&nbsp;</span>
          <span style="color:rgb(116,226,208)" v-if="this.goodsItemIdData.postpone=='1'">{{"[上架]"}}</span>
          <span style="color:rgb(116,226,208)" v-if="this.goodsItemIdData.recommend=='1'">{{"[推荐]"}}</span>
          <span style="color:rgb(116,226,208)" v-if="this.goodsItemIdData.hot=='1'">{{"[热门]"}}</span>
          <span style="color:rgb(116,226,208)">{{"[录播+直播]"}}</span>
          <div style="margin-top:14px;" v-html="goodsItemIdData.detail"></div>
          <span style="display:block;margin-top:14px;">
            <span style="color:red">￥{{this.goodsItemIdData.price}}</span>
            <span
              style="text-decoration:line-through;color:rgb(162,170,188)"
            >￥{{this.goodsItemIdData.originalPrice}}</span>
          </span>
          <div style="margin-top:14px;color:rgb(162,170,188)">
            <span>销量：{{this.goodsItemIdData.actualSellCount==null?0:this.goodsItemIdData.actualSellCount}}&nbsp;&nbsp;</span>
            <span>内容：{{this.goodsItemIdData.goodsItemCount}}</span>
          </div>
        </div>
      </div>
    </el-card>

    <el-card class="box-card" style="margin-top: 20px;">
      <el-table
        ref="multipleTable"
        :data="page.rows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%;"
        border
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-background="rgba(255, 255, 255, 0.8)"
      >
        <el-table-column show-overflow-tooltip type="index" width="80" label="排序"></el-table-column>
        <el-table-column show-overflow-tooltip prop="name" label="内容"></el-table-column>
        <el-table-column show-overflow-tooltip prop="type" label="类型"></el-table-column>
        <el-table-column show-overflow-tooltip prop="sell" label="是否上架">
          <template slot-scope="row">{{row.row.sell=="1"?"上架":"下架"}}</template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="courseName" label="所属课程"></el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total, prev, pager, next"
        style="margin-top: 20px;text-align: right;"
        :total="page.total"
        :page-size="page.pageSize"
        :current-page="page.pageNumber"
        @size-change="sizeChange"
        @current-change="currentChange"
      ></el-pagination>
    </el-card>

    <el-dialog title="添加视频" :visible.sync="addVideoVisible" width="800px" left>
      <el-form ref="searchForm" :model="videoSearchForm" :label-width="formLabelWidth">
        <el-row>
          <el-col :sm="8" :md="8" :lg="8">
            <el-form-item label="所属科目">
              <el-cascader
                :show-all-levels="false"
                ref="tree"
                @change="videoSubjectChange"
                :options="subjectTreeList"
                :props="subjectTreeProps"
                collapse-tags
                clearable
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :sm="8" :md="8" :lg="8">
            <el-form-item label="课程名称">
              <el-input v-model="videoSearchForm.name" placeholder="请输入课程名称" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="8" :md="8" :lg="8">
            <el-button
              style="margin-left:20px;"
              type="primary"
              @click="videocoursePageList"
              icon="el-icon-search"
            >查询</el-button>
          </el-col>
        </el-row>
      </el-form>
      <el-table
        ref="multipleTable"
        :data="videocoursePage.rows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%;"
        border
        @selection-change="selectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="subjectCourseName" label="所属课程"></el-table-column>
        <el-table-column prop="name" label="课程名称"></el-table-column>
        <el-table-column prop="createTime" label="创建时间"></el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total, prev, pager, next"
        style="margin-top: 20px;text-align: right;"
        :total="videocoursePage.total"
        :page-size="videocoursePage.pageSize"
        :current-page="videocoursePage.pageNumber"
        @size-change="videoSizeChange"
        @current-change="videoCurrentChange"
      ></el-pagination>
      <div slot="footer" class="dialog-footer" style="text-align:right">
        <el-button @click="addVideoVisible = false">取 消</el-button>
        <el-button @click="addGoodsItemBatch" type="primary">添 加</el-button>
      </div>
    </el-dialog>
    <el-dialog title="添加题库" :visible.sync="addSubjectVisible" width="800px" left>
      <el-form ref="searchForm" :model="subjectForm" :label-width="formLabelWidth">
        <el-row>
          <el-col :sm="8" :md="8" :lg="8">
            <el-form-item label="所属科目">
              <el-cascader
                :show-all-levels="false"
                ref="tree"
                @change="subjectChange"
                :options="subjectTreeList"
                :props="subjectTreeProps"
                collapse-tags
                clearable
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :sm="8" :md="8" :lg="8">
            <el-button
              style="margin-left:20px;"
              type="primary"
              @click="pageListExamType"
              icon="el-icon-search"
            >查询</el-button>
          </el-col>
        </el-row>
      </el-form>
      <el-table
        ref="multipleTable"
        :data="subjectPage.rows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%;"
        border
        @selection-change="subjectSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="name" label="所属课程">
          <template
            slot-scope="row"
          >{{row.row.ppname!=null?row.row.ppname+"-":""}}{{row.row.pname!=null?row.row.pname+"-":""}}{{row.row.name!=null?row.row.name:""}}</template>
        </el-table-column>
        <el-table-column prop="examType" label="试卷类型"></el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total, prev, pager, next"
        style="margin-top: 20px;text-align: right;"
        :total="subjectPage.total"
        :page-size="subjectPage.pageSize"
        :current-page="subjectPage.pageNumber"
        @size-change="subjectSizeChange"
        @current-change="subjectCurrentChange"
      ></el-pagination>
      <div slot="footer" class="dialog-footer" style="text-align:right">
        <el-button @click="addSubjectVisible = false">取 消</el-button>
        <el-button @click="addGoodsItemBatch" type="primary">添 加</el-button>
      </div>
    </el-dialog>
    <el-dialog title="添加章节" :visible.sync="addChapterVisible" width="800px" left>
      <el-form :model="chapterForm" label-width="80px">
        <el-row :gutter="20">
          <el-col :sm="8" :md="8" :lg="8">
            <el-form-item label="科目类型" label-width="80px" prop="ppid">
              <el-select
                v-model="chapterForm.ppid"
                placeholder="请选择"
                clearable
                @change="choosePPid()"
              >
                <el-option
                  v-for="item in ppList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :sm="8" :md="8" :lg="8">
            <el-form-item label="所属科目" label-width="80px" prop="pid">
              <el-select v-model="chapterForm.pid" placeholder="请选择" clearable>
                <el-option v-for="item in pList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :sm="4" :md="4" :lg="4">
            <el-button type="primary" @click="pageListChapter" icon="el-icon-search">查询</el-button>
          </el-col>
        </el-row>
      </el-form>
      <el-table
        ref="multipleTable"
        :data="chapterPage.rows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%;"
        border
        @selection-change="chapterSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="name" label="所属课程">
          <template
            slot-scope="row"
          >{{row.row.ppname!=null?row.row.ppname+"-":""}}{{row.row.pname!=null?row.row.pname+"-":""}}{{row.row.name!=null?row.row.name:""}}</template>
        </el-table-column>
        <el-table-column prop="name" label="课程名称"></el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total, prev, pager, next"
        style="margin-top: 20px;text-align: right;"
        :total="chapterPage.total"
        :page-size="chapterPage.pageSize"
        :current-page="chapterPage.pageNumber"
        @size-change="chapterSizeChange"
        @current-change="chapterCurrentChange"
      ></el-pagination>
      <div slot="footer" class="dialog-footer" style="text-align:right">
        <el-button @click="addChapterVisible = false">取 消</el-button>
        <el-button @click="addGoodsItemBatch" type="primary">添 加</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pList: [], //二级列表
      ppList: [], //一级列表
      videoCourseIds: [],
      subjectTreeList: [], //科目
      typeList: [], //试题题型
      subjectTreeProps: {
        value: "id",
        label: "name",
        children: "children",
        multiple: true
      },
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      },
      videocoursePage: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      },
      subjectPage: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      },
      chapterPage: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        level: 2,
        sortName: "",
        sortOrder: ""
      },
      loading: false,
      addVideoVisible: false,
      addSubjectVisible: false,
      addChapterVisible: false,
      searchForm: {},
      videoSearchForm: {},
      subjectForm: {},
      chapterForm: {
        ppid: "",
        pid: ""
      },
      formLabelWidth: "80px",
      selection: "",
      multipleSelection: "",
      ids: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      fileAction: `${process.env.BASE_URL}/goodsItem/upload`,
      fileList: [],
      loading: true,
      goodsItemIdData: [],
      type: ""
    };
  },
  methods: {
    addGoodsVideo() {
      this.type = "视频课程";
      this.getSubjectTreeList();
      this.videocoursePageList();
      this.addVideoVisible = true;
    },
    addGoodsSubject() {
      this.type = "试卷";
      this.getSubjectTreeList();
      this.pageListExamType();
      this.addSubjectVisible = true;
    },
    addGoodsChapter() {
      this.type = "章节";
      this.getTypeLit();
      this.pageListChapter();
      this.addChapterVisible = true;
    },
    videoSubjectChange(val) {
      this.videoSearchForm.courseIds = [];
      val.forEach(item => {
        this.videoSearchForm.courseIds.push(item[2]);
      });
    },
    subjectChange(val) {
      this.subjectForm.ids = [];
      val.forEach(item => {
        this.subjectForm.ids.push(item[2]);
      });
    },
    videocoursePageList() {
      this.videoSearchForm.pageSize = this.videocoursePage.pageSize;
      this.videoSearchForm.pageNumber = this.videocoursePage.pageNumber;
      this.videoSearchForm.sortName = this.videocoursePage.sortName;
      this.videoSearchForm.sortOrder = this.videocoursePage.sortOrder;
      this.api.videoCourse
        .pageList(this.videoSearchForm)
        .then(result => {
          this.videocoursePage.rows = result.data.records;
          this.videocoursePage.total = result.data.total;
        })
        .catch(error => {
          console.log(error);
        });
    },
    pageListExamType() {
      this.subjectForm.pageSize = this.subjectPage.pageSize;
      this.subjectForm.pageNumber = this.subjectPage.pageNumber;
      this.subjectForm.sortName = this.subjectPage.sortName;
      this.subjectForm.sortOrder = this.subjectPage.sortOrder;
      this.api.goodsItem
        .pageListExamType(this.subjectForm)
        .then(result => {
          this.subjectPage.rows = result.data.records;
          this.subjectPage.total = result.data.total;
        })
        .catch(error => {
          console.log(error);
        });
    },
    pageListChapter() {
      this.chapterForm.pageSize = this.chapterPage.pageSize;
      this.chapterForm.pageNumber = this.chapterPage.pageNumber;
      this.chapterForm.level = this.chapterPage.level;
      this.chapterForm.sortName = this.chapterPage.sortName;
      this.chapterForm.sortOrder = this.chapterPage.sortOrder;
      this.api.subjectCourse
        .getPageList(this.chapterForm)
        .then(result => {
          this.chapterPage.rows = result.data.records;
          this.chapterPage.total = result.data.total;
        })
        .catch(error => {
          console.log(error);
        });
    },
    addGoodsItemBatch() {
      this.api.goodsItem.addGoodsItemBatch(this.ids).then(result => {
        if (result.success) {
          this.addVideoVisible = false;
          this.addSubjectVisible = false;
          this.addChapterVisible = false;
          this.pageList();
          this.ids = [];
        } else {
          this.$message(result.message);
        }
      });
    },

    getSubjectTreeList() {
      this.api
        .getSubjectCourseTreeList()
        .then(result => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                if (items.children.length != 0) {
                  for (let itemss of items.children) {
                    delete itemss.children;
                  }
                } else {
                  // delete items.children;
                }
              }
            } else {
              // delete item.children;
            }
          }
          this.subjectTreeList = result.data;
        })
        .catch(error => {
          console.log(error);
        });

      // 获取试题类型
      this.api.question
        .questionTypeList()
        .then(result => {
          this.typeList = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    //获取一级列表
    getTypeLit() {
      this.api.subjectCourse
        .getSubjectCourseListByPid({
          pid: 0
        })
        .then(result => {
          this.ppList = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },

    //获取二级列表
    choosePPid() {
      this.api.subjectCourse
        .getSubjectCourseListByPid({
          pid: this.chapterForm.ppid
        })
        .then(result => {
          this.pList = result.data;
          this.chapterForm.pid = "";
        })
        .catch(error => {
          console.log(error);
        });
    },
    getGoodsItemData() {
      this.api.goodsInfo
        .getGoodsInfo({ id: this.$route.query.updatePageGoodsItem })
        .then(result => {
          this.goodsItemIdData = result.data;
          this.pageList();
        });
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    videoSizeChange(pageSize) {
      this.videocoursePage.pageSize = pageSize;
      this.videocoursePageList();
    },
    videoCurrentChange(pageNumber) {
      this.videocoursePage.pageNumber = pageNumber;
      this.videocoursePageList();
    },
    subjectSizeChange(pageSize) {
      this.subjectPage.pageSize = pageSize;
      this.pageListExamType();
    },
    subjectCurrentChange(pageNumber) {
      this.subjectPage.pageNumber = pageNumber;
      this.pageListExamType();
    },
    chapterSizeChange(pageSize) {
      this.chapterPage.pageSize = pageSize;
      this.pageListChapter();
    },
    chapterCurrentChange(pageNumber) {
      this.chapterPage.pageNumber = pageNumber;
      this.pageListChapter();
    },
    selectionChange(val) {
      this.multipleSelection = val;
      this.ids = val.map(e => ({
        objectId: e.id,
        goodsId: this.goodsItemIdData.id,
        type: this.type
      }));
    },
    subjectSelectionChange(val) {
      this.ids = val.map(e => ({
        objectId: e.id,
        goodsId: this.goodsItemIdData.id,
        type: this.type,
        examType: e.examType
      }));
    },
    chapterSelectionChange(val) {
      this.ids = val.map(e => ({
        objectId: e.id,
        goodsId: this.goodsItemIdData.id,
        type: this.type
      }));
    },
    pageList() {
      this.loading = true;
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.sortOrder = this.page.sortOrder;
      this.searchForm.goodsId = this.goodsItemIdData.id;
      this.api.goodsItem
        .pageList(this.searchForm)
        .then(result => {
          this.page.rows = result.data.records;
          this.page.total = result.data.total;
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  mounted() {
    this.getGoodsItemData();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/goodsInfo/goodsItem.vue